import styled from 'styled-components';

export const StyledSection = styled.section`
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;
